import store from "../store";
import {
    setPillBadges,
    onModelUpdated,
    createWorkers,
    getAllRowsFromGrid,
    getActiveModule,
    getGridUpdateConfig,
} from "./utils";
import {
    updatePoFilterCount,
    updateCaFilterCount,
    updateAdFilterCount,
    updatePdFilterCount,
    updateIsRuleFiltersApplied,
} from "@features/filtersSlice";
import { GridApi } from "ag-grid-community";
import {
    ISetUpdateGridDataParams,
    IUpdatedGridData,
    IUpdatedGridDataResponse,
    Modules,
    TClientTags,
    TCommonRowData,
    TGridFiltersValue,
    TSelectionValue,
} from "./common-types";
import { getUpdatedGridData } from "@/workers/grid-params.worker";
import { gridUpdateConfig } from "./constants";
import { EnhancedStore } from "@reduxjs/toolkit";

type TGridRef = {
    api: GridApi;
};

export const ruleLinkFilters = (gridRef: TGridRef) => {
    const gridApi = gridRef.api;
    const tabRedirectionFilter = JSON.parse(
        sessionStorage.getItem("tabRedirection")
    );

    if (tabRedirectionFilter && typeof tabRedirectionFilter === "object") {
        const { filter } = tabRedirectionFilter;
        sessionStorage.setItem("activeFilters", JSON.stringify(filter));
        const lastDateRange = filter.report_date.filter;
        sessionStorage.setItem("lastDateRange", lastDateRange);
        sessionStorage.setItem(
            "currentDateFilter",
            JSON.stringify({ report_date: filter.report_date })
        );
        gridApi.setFilterModel(filter);
        gridApi.onFilterChanged();
        onModelUpdated(gridRef);
        store.dispatch(updateIsRuleFiltersApplied(false));
    }
};

/**
 * ! Function for setting the badge count need optimization in future version...
 */

export const getFilterCount = (module: string) => {
    const {
        adgroupsData,
        campaignsData,
        keywordsData,
        productsData,
        portfoliosData,
        placementsData,
        portfolioFilters,
        campaignFilters,
        adgroupFilters,
        productFilters,
    } = store.getState();

    let curAdgroupsData = [];
    let curCampaignsData = [];
    let curKeywordsData = [];
    let curProductsData = [];
    let curPlacementsData = [];

    const campaignsFilteredData: TCommonRowData = [];
    const adgroupsFilteredData: TCommonRowData = [];
    const keywordsFilteredData: TCommonRowData = [];
    const productsFilteredData: TCommonRowData = [];
    const placementsFilteredData: TCommonRowData = [];
    if (
        campaignsFilteredData.length === 0 &&
        adgroupsFilteredData.length === 0 &&
        keywordsFilteredData.length === 0 &&
        productsFilteredData.length === 0 &&
        placementsFilteredData.length === 0
    ) {
        curAdgroupsData = [...adgroupsData.value];
        curCampaignsData = [...campaignsData.value];
        curKeywordsData = [...keywordsData.value];
        curProductsData = [...productsData.value];
        curPlacementsData = [...placementsData.value];
    } else {
        if (module === "portfolios") {
            campaignsFilteredData.length = 0;
            adgroupsFilteredData.length = 0;
            keywordsFilteredData.length = 0;
            productsFilteredData.length = 0;
            placementsFilteredData.length = 0;
        }

        // curPortfolioData = [...portfoliosFilteredData];
        curAdgroupsData = [...adgroupsFilteredData];
        curCampaignsData = [...campaignsFilteredData];
        curKeywordsData = [...keywordsFilteredData];
        curProductsData = [...productsFilteredData];
        curPlacementsData = [...placementsFilteredData];
    }

    let moduleFilter: TSelectionValue;

    switch (module) {
        case "portfolios":
            moduleFilter = portfolioFilters.value;
            getFilteredData(
                moduleFilter.adgroupFilters,
                curAdgroupsData,
                adgroupsFilteredData
            );
            getFilteredData(
                moduleFilter.keywordFilters,
                curKeywordsData,
                keywordsFilteredData
            );
            getFilteredData(
                moduleFilter.productFilters,
                curProductsData,
                productsFilteredData
            );
            getFilteredData(
                moduleFilter.campaignFilters,
                curCampaignsData,
                campaignsFilteredData
            );
            getFilteredData(
                moduleFilter.placementsFilters,
                curPlacementsData,
                placementsFilteredData
            );
            break;

        case "campaigns":
            moduleFilter = campaignFilters.value;
            getFilteredData(
                moduleFilter.adgroupFilters,
                curAdgroupsData,
                adgroupsFilteredData
            );
            getFilteredData(
                moduleFilter.keywordFilters,
                curKeywordsData,
                keywordsFilteredData
            );
            getFilteredData(
                moduleFilter.productFilters,
                curProductsData,
                productsFilteredData
            );
            getFilteredData(
                moduleFilter.placementsFilters,
                curPlacementsData,
                placementsFilteredData
            );
            break;

        case "products":
            moduleFilter = productFilters.value;
            getFilteredData(
                moduleFilter.keywordFilters,
                curKeywordsData,
                keywordsFilteredData
            );
            getFilteredData(
                moduleFilter.campaignFilters,
                curCampaignsData,
                campaignsFilteredData
            );
            getFilteredData(
                moduleFilter.adgroupFilters,
                curAdgroupsData,
                adgroupsFilteredData
            );
            getFilteredData(
                moduleFilter.placementsFilters,
                curPlacementsData,
                placementsFilteredData
            );
            break;

        case "adgroups":
            moduleFilter = adgroupFilters.value;
            getFilteredData(
                moduleFilter.keywordFilters,
                curKeywordsData,
                keywordsFilteredData
            );
            getFilteredData(
                moduleFilter.campaignFilters,
                curCampaignsData,
                campaignsFilteredData
            );
            getFilteredData(
                moduleFilter.productFilters,
                curProductsData,
                productsFilteredData
            );
            getFilteredData(
                moduleFilter.placementsFilters,
                curPlacementsData,
                placementsFilteredData
            );
            break;
    }

    const countObj = {
        kwCount: keywordsFilteredData.length,
        adCount: adgroupsFilteredData.length,
        caCount: campaignsFilteredData.length,
        pdCount: productsFilteredData.length,
        plCount: placementsFilteredData.length,
    };

    const initCountObj = {
        poInitCount: portfoliosData.value.length,
        caInitCount: campaignsData.value.length,
        adInitCount: adgroupsData.value.length,
        kwInitCount: keywordsData.value.length,
        pdInitCount: productsData.value.length,
        plInitCount: placementsData.value.length,
    };

    setBadgeCount(module, countObj, initCountObj);
};

/**
 * * Filters array | Data to be filtered array | Filtered Array
 */

const getFilteredData = (
    filtersObject: TGridFiltersValue,
    dataToBeFiltered: TCommonRowData,
    filteredArr: TCommonRowData
) => {
    const { filterData, filterKey } = filtersObject;
    filteredArr.push(
        ...dataToBeFiltered.filter((data: any) =>
            filterData.includes(data[filterKey])
        )
    );
};

const setBadgeCount = (
    key: string,
    countObject: Record<string, number>,
    initCountObj: Record<string, number>
) => {
    const { kwCount, adCount, caCount, pdCount, plCount } = countObject;
    const { kwInitCount, adInitCount, caInitCount, pdInitCount, poInitCount, plInitCount } =
        initCountObj;

    if (caCount === 0 && kwCount === 0 && adCount === 0 && pdCount === 0 && plCount === 0) {
        setPillBadges("campaigns-badge", caInitCount);
        setPillBadges("adgroups-badge", adInitCount);
        setPillBadges("keywords-badge", kwInitCount);
        setPillBadges("products-badge", pdInitCount);
        setPillBadges("placements-badge", plInitCount);
    } else {
        switch (key) {
            case "portfolios":
                setPillBadges("campaigns-badge", caCount);
                setPillBadges("adgroups-badge", adCount);
                setPillBadges("keywords-badge", kwCount);
                setPillBadges("products-badge", pdCount);
                setPillBadges("placements-badge", plCount);
                store.dispatch(
                    updatePoFilterCount({
                        module: key,
                        caCount: caCount,
                        adCount: adCount,
                        kwCount: kwCount,
                        pdCount: pdCount,
                        plCount: plCount,
                    })
                );
                break;
            case "campaigns":
                setPillBadges("adgroups-badge", adCount);
                setPillBadges("keywords-badge", kwCount);
                setPillBadges("products-badge", pdCount);
                setPillBadges("placements-badge", plCount);
                store.dispatch(
                    updateCaFilterCount({
                        module: key,
                        poCount: poInitCount,
                        adCount: adCount,
                        kwCount: kwCount,
                        pdCount: pdCount,
                        plCount: plCount,
                    })
                );
                break;
            case "adgroups":
                setPillBadges("campaigns-badge", caCount);
                setPillBadges("keywords-badge", kwCount);   
                setPillBadges("products-badge", pdCount);
                setPillBadges("placements-badge", plCount);
                store.dispatch(
                    updateAdFilterCount({
                        module: key,
                        poCount: poInitCount,
                        caCount: caCount,
                        kwCount: kwCount,
                        pdCount: pdCount,
                        plCount: plCount,
                    })
                );
                break;
            case "products":
                setPillBadges("campaigns-badge", caCount);
                setPillBadges("adgroups-badge", adCount);
                setPillBadges("keywords-badge", kwCount);
                setPillBadges("placements-badge", plCount);
                store.dispatch(
                    updatePdFilterCount({
                        module: key,
                        poCount: poInitCount,
                        adCount: adCount,
                        kwCount: kwCount,
                        caCount: caCount,
                        plCount: plCount,
                    })
                );
                break;
        }
    }
};

export const setUpdateGridData = async ({
    params,
    value,
    additionalValuesToUpdate,
    isReduxState,
    bulkRequiredConfig,
    modalParamToChange,
}: ISetUpdateGridDataParams) => {
    //* For bulk operations bulkRequiredConfig has to be used and  for single getGridUpdateConfig fn will return a config
    const requiredConfig =
        bulkRequiredConfig && Object.keys(bulkRequiredConfig).length
            ? bulkRequiredConfig
            : getGridUpdateConfig(
                params,
                value,
                additionalValuesToUpdate,
                modalParamToChange
            );
    const { activeModule } = getActiveModule();
    const setGridState = gridUpdateConfig[activeModule as Modules].setGridState;
    const gridData = getAllRowsFromGrid();
    const config = { ...requiredConfig, gridData } as IUpdatedGridData;
    const { rowData, rowIdentifier }: IUpdatedGridDataResponse =
        await (window.Worker
            ? createWorkers("updateGridParam", config)
            : getUpdatedGridData(config));
    isReduxState
        ? store.dispatch(setGridState(rowData))
        : setGridState(rowData);

    /**
     * * Below code will update, all the depended grids value once the main grid value is updated
     * * For eg. If campaign_name is changed in Campaign, then this has to be reflected in keywords grid also
     */

    const gridsToUpdate =
        gridUpdateConfig[activeModule as Modules].gridsToUpdateParams[
            config.paramToChange
        ];
    if (gridsToUpdate?.length) {
        for (const gridToUpdate of gridsToUpdate) {
            if (
                (store as EnhancedStore).getState()[gridToUpdate.gridData]
                    .value
                    .length
            ) {
                const bulkConfig: IUpdatedGridData = {
                    selectedRows: (store as EnhancedStore).getState()[
                        gridToUpdate.gridData
                    ].value,
                    paramToChange: config.paramToChange,
                    paramToFilter: config.paramToFilter,
                    isRelatedGrid: true,
                    newParamValue: value as string | number | boolean | string[] | TClientTags[],
                    rowIdentifier,
                };
                const relativeRowData: IUpdatedGridDataResponse =
                    await (window.Worker
                        ? createWorkers("updateGridParam", bulkConfig)
                        : getUpdatedGridData(bulkConfig));
                store.dispatch(gridToUpdate.setGridState(relativeRowData));
            }
        }
    }
};
